// extracted by mini-css-extract-plugin
export default {"wrapper":"LogIn_wrapper__PdZMG","form":"LogIn_form__ILRVD","form__submit":"LogIn_form__submit__DSz+g","form__submit-inner":"LogIn_form__submit-inner__EpfLh"};